// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";

// Models

// Dto
import { StatementDetailDTO } from "Globals/Models/DTO/StatementDetailDTO";

export class StatementDetailsModel extends ModelBase<StatementDetailsModel, StatementDetailsAndRelated> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public hasActiveIVCA: boolean = true;
    @MobX.observable public hasHadRepossession: boolean = true;
    @MobX.observable public hasAccessToCosts: boolean = false;
    @MobX.observable public hasLateLoanPayments: boolean = true;
    @MobX.observable public hasLateHomePayments: boolean = true;
    @MobX.observable public hasHadCCJ: boolean = true;
    @MobX.observable public hasBeenBancrupt: boolean = true;
    @MobX.observable public isReceivingHousingBenefit: boolean = true;
    @MobX.observable public notes: string | null = null;
    @MobX.observable public hasBeenEmployedByHHA: boolean = true;
    @MobX.observable public hasRelationshipWithHHA: boolean = true;
    @MobX.observable public hhaEmployeeName: string = "";
    @MobX.observable public relationshipTypeId: string | null = "placeholder";
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: StatementDetailsAndRelated): void => {
        if (model !== null && model !== undefined) {
            this.id = model.statementDetail.id;
            this.formId = model.statementDetail.formId;
            this.applicantId = model.statementDetail.applicantId;
            this.hasActiveIVCA = model.statementDetail.hasActiveIVCA;
            this.hasHadRepossession = model.statementDetail.hasHadRepossession;
            this.hasAccessToCosts = model.statementDetail.hasAccessToCosts;
            this.hasLateLoanPayments = model.statementDetail.hasLateLoanPayments;
            this.hasLateHomePayments = model.statementDetail.hasLateHomePayments;
            this.hasHadCCJ = model.statementDetail.hasHadCCJ;
            this.hasBeenBancrupt = model.statementDetail.hasBeenBancrupt;
            this.isReceivingHousingBenefit = model.statementDetail.isReceivingHousingBenefit;
            this.notes = model.statementDetail.notes;
            this.hasBeenEmployedByHHA = model.statementDetail.hasBeenEmployedByHHA;
            this.hasRelationshipWithHHA = model.statementDetail.hasRelationshipWithHHA;
            this.hhaEmployeeName = model.statementDetail.hhaEmployeeName;
            this.relationshipTypeId = model.statementDetail.relationshipTypeId;
            this.relationshipTypeId =
                model.statementDetail.relationshipTypeId == "" || model.statementDetail.relationshipTypeId == null ? "placeholder" : model.statementDetail.relationshipTypeId;
            this.createdDate = model.statementDetail.createdDate;
            this.isDeleted = model.statementDetail.isDeleted;
        }
    };

    @MobX.action
    public fromStatementDetailDto = (model: StatementDetailDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.hasActiveIVCA = model.hasActiveIVCA;
            this.hasHadRepossession = model.hasHadRepossession;
            this.hasAccessToCosts = model.hasAccessToCosts;
            this.hasLateLoanPayments = model.hasLateLoanPayments;
            this.hasLateHomePayments = model.hasLateHomePayments;
            this.hasHadCCJ = model.hasHadCCJ;
            this.hasBeenBancrupt = model.hasBeenBancrupt;
            this.isReceivingHousingBenefit = model.isReceivingHousingBenefit;
            this.notes = model.notes;
            this.hasBeenEmployedByHHA = model.hasBeenEmployedByHHA;
            this.hasRelationshipWithHHA = model.hasRelationshipWithHHA;
            this.hhaEmployeeName = model.hhaEmployeeName;
            this.relationshipTypeId = model.relationshipTypeId == "" || model.relationshipTypeId == null ? "placeholder" : model.relationshipTypeId;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): StatementDetailDTO => {
        let model: StatementDetailDTO = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            hasActiveIVCA: this.hasActiveIVCA,
            hasHadRepossession: this.hasHadRepossession,
            hasAccessToCosts: this.hasAccessToCosts,
            hasLateLoanPayments: this.hasLateLoanPayments,
            hasLateHomePayments: this.hasLateHomePayments,
            hasHadCCJ: this.hasHadCCJ,
            hasBeenBancrupt: this.hasBeenBancrupt,
            isReceivingHousingBenefit: this.isReceivingHousingBenefit,
            notes: this.notes,
            hasBeenEmployedByHHA: this.hasBeenEmployedByHHA,
            hasRelationshipWithHHA: this.hasRelationshipWithHHA,
            hhaEmployeeName: this.hhaEmployeeName,
            relationshipTypeId: this.relationshipTypeId == "placeholder" ? "" : this.hasRelationshipWithHHA == true ? this.relationshipTypeId : "",
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };
}

// Extend interface to accept new form sections
export interface StatementDetailsAndRelated {
    statementDetail: StatementDetailDTO;
}
